import { render } from "./CardFourtyOne.vue?vue&type=template&id=97df1f54"
import script from "./CardFourtyOne.vue?vue&type=script&lang=js"
export * from "./CardFourtyOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__